import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaD_Van_Right: React.FC<AreaSVGProps> = ({
  fill = '#FFD91B',
  stroke = '#FFD91B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="197"
      height="164"
      viewBox="0 0 197 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_d_van_right"
          x="0"
          y="0"
          width="197"
          height="164"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_d_van_right)">
        <path
          d="M1.07373 1C0.830524 38.0628 1.10652 79.3049 3.26709 119.065L3.48389 122.933L5.19189 148.184C28.7878 156.811 53.54 162.193 86.6265 162.547C118.769 162.891 149.987 160.55 170.38 158.119L171.792 124.074C167.403 122.003 160.935 117.984 154.931 111.711C146.678 103.087 139.138 90.0358 139.138 71.8164C139.138 52.2259 147.705 37.7318 159.731 28.1221C170.229 19.7336 183.276 15.1147 195.486 13.7744V1H1.07373Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
